import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { handleTitle } from '../../actions/interface';
import { handleRegisterModal } from '../../actions/auth';
import * as S from './styles';

// Импорт компонентов
import WelcomeSection from './components/WelcomeSection';
import ContentBlocksSection from './components/ContentBlocksSection';
import RoboBlockSection from './components/RoboBlockSection';
import BlackSwanSection from './components/BlackSwanSection';
import FooterSection from './components/FooterSection';
import ModalManager from './components/ModalManager';
import MobileAppBanner from './components/MobileAppBanner';

// Импорт кастомных хуков
import useMainPage from './hooks/useMainPage';
import useMobileAppBanner from './hooks/useMobileAppBanner';
import useAppMetricaLinks from './hooks/useAppMetricaLinks';

const MainPage = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((s) => s.auth?.auth);
  const i18n = useAppSelector((s) => s.i18n);
  const handleRegisterModalFn = useCallback(
    (...args) => dispatch(handleRegisterModal(...args)),
    [dispatch]
  );
  const handleTitleFn = useCallback((...args) => dispatch(handleTitle(...args)), [dispatch]);
  const { state, handlers } = useMainPage({
    auth,
    handleRegisterModal: handleRegisterModalFn,
    handleTitle: handleTitleFn,
    i18n,
  });

  const { showMobileBanner, handleCloseBanner } = useMobileAppBanner();
  const { appStoreUrl } = useAppMetricaLinks();

  return (
    <S.Container>
      {showMobileBanner && (
        <MobileAppBanner appStoreUrl={appStoreUrl} onClose={handleCloseBanner} />
      )}

      <WelcomeSection
        i18n={i18n}
        auth={auth}
        isScrolled={state.isScrolled}
        onRegisterClick={handlers.handleRegisterClick}
      />

      <ContentBlocksSection i18n={i18n} />

      <RoboBlockSection i18n={i18n} />

      <BlackSwanSection i18n={i18n} />

      <FooterSection
        i18n={i18n}
        onAgreementClick={handlers.handleAgreementClick}
        onPolicyClick={handlers.handlePolicyClick}
      />

      <ModalManager
        isAgreementModalOpen={state.isAgreementModalOpen}
        isPolicyModalOpen={state.isPolicyModalOpen}
        onAgreementClose={handlers.handleAgreementClose}
        onPolicyClose={handlers.handlePolicyClose}
      />
    </S.Container>
  );
};

export default MainPage;
